import { autorun, observable, action, computed } from 'mobx'
import client from '../../../helpers/client'
import { asNormalizedMaps, asNormalizedArrays } from '../../../helpers/json-normalizer'
import encodeParamsForRails from '../../../helpers/encodeParamsForRails'

class Store {
  @observable ready = false
  @observable loading = true
  @observable franchise
  @observable addOnCategories = []
  @observable addOns = []

  constructor({ widgetStore, selectedCategoryIds }) {
    this.widgetStore = widgetStore
    this.host = widgetStore.host
    this.selectedCategoryIds = selectedCategoryIds
    console.log({ selectedCategoryIds })
  }

  @computed get showCategoryHeaders() {
    return this.addOnCategories.length > 1
  }

  async setup() {
    this.loading = true
    await this.loadFranchise()
    await this.loadAddOns()
    this.ready = true
    this.loading = false
  }

  loadFranchise() {
    return client.get(`${this.host}/api/v1/franchise`)
      .then(response => {
        const data = asNormalizedArrays(response.data)
        this.franchise = Object.values(data.franchise)[0]
      })
      .catch(error => (this.widgetStore.unrecoverableError = error))
  }

  loadAddOns() {
    let params = {
      include: 'add_on_category',
      only_widget_visible: 1,
    }
    if(this.selectedCategoryIds) {
      params.category_ids = this.selectedCategoryIds
    }
    const url = `${this.host}/api/v1/add_ons?${encodeParamsForRails(params)}`
    return client.get(url)
      .then(response => {
        const data = asNormalizedMaps(response.data)
        this.addOnCategories = Array.from(data.addOnCategory.values())
          .sort((a, b) => a.attributes.position - b.attributes.position)
        this.addOns = data.addOn
      })
      .catch(error => (this.widgetStore.unrecoverableError = error))
  }

  addOnsForCategory(addOnCategory) {
    const addOnIds = addOnCategory.relationships.addOns.data.map(addOn => addOn.id)
    return addOnIds
      .map(id => this.addOns.get(id))
      .filter(addOn => addOn)
      .sort((a, b) => a.attributes.position - b.attributes.position)
  }
}

export default Store
